<template>
  <div class="single-choice-form">
    <label for="single-choice_question">Question<lang-toggler :lang="question.lang" @input="question.lang = $event" @applyAll="onApplyToAllLangs($event)"/></label>
    <textarea id="single-choice_question" v-model="question[question.lang]" v-on:blur="updateLangField('question', question.lang, $event)" />
    <label for="single-choice_image">Action with Image</label>
    <input type="checkbox" id="single-choice_image" v-model="hasImage" v-on:blur="updateField('hasImage', $event.target.checked)" />
    <ul>
      <li v-for="(option, key) in options" v-bind:key="keyPart + key">
        <SingleChocieField :id="'single_choice_option' + key" type="text" :option="option" :singleChoiceId="tag.id" :singleChoiceHasImage="hasImage" v-on:update="(data) => updateOption(key, data)" v-on:delete="deleteOption(key)" />
      </li>
    </ul>
    <a class="icon-button" href="#" v-on:click.prevent="addOption">
      <i class="material-icons">add</i>
      <label>Add Option</label>
    </a>

    <label v-if="!hasImage" for="quiz_alignement">Alignement</label>
    <align-picker v-if="!hasImage" name="quiz_alignement" v-on:pick="updateField('alignement', $event)" :value="alignement" :options="['v-layout', 'h-layout']" />

    <label for="single-choice__alignement">Color Scheme</label>
    <color-scheme-select v-on:pick="updateField('colorScheme', $event)" :modelItem="colorScheme" :value="colorScheme.key" :options="colorOptions" />

    <label for="single-choice__feedback-time">Time for Feedback</label>
    <input type="number" id="single-choice__feedback-time" v-model="feedbackTime" v-on:blur="updateField('feedbackTime', $event)" />

  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import SingleChocieField from './singleChoiceField'
import LangToggler from './langToggler'
import AlignPicker from './alignPicker'
import ColorSchemeSelect from './colorSchemeSelect'
import { multiLangTextObject } from './../../utils/multiLang'

const colorOptions = [
  {
    id: 'quiz-1',
    label: 'default'
  },
  {
    id: 'quiz-transparent-light',
    label: 'semi transparent for light background'
  },
  {
    id: 'quiz-transparent-dark',
    label: 'semi transparent for dark background'
  },
  {
    id: 'quiz-custom-color',
    label: 'custom'
  },
  {
    id: 'quiz-custom-color-2',
    label: 'custom 2'
  }
]

export default {
  name: 'single-choice-form',
  props: ['tag'],
  created() {
    const meta = (this.tag && this.tag.meta) || {}
    this.initTag(meta)
  },
  data() {
    return {
      colorOptions: colorOptions,
      keyPart: null,
      name: null,
      question: null,
      feedbackTime: null,
      hasImage: false,
      options: null,
      alignement: null,
      colorScheme: {}
    }
  },
  components: {
    SingleChocieField,
    LangToggler,
    AlignPicker,
    ColorSchemeSelect
  },
  computed: {
    ...mapState(['selection']),
    ...mapGetters(['currentTime'])
  },
  methods: {
    ...mapMutations(['updateSingleChoice', 'setPlayerTime']),
    initTag(meta) {
      const singleChoice = meta.singleChoice || {}
      this.keyPart = new Date().toTimeString()
      this.name = meta.name
      this.question = multiLangTextObject(singleChoice.question)
      this.feedbackTime = singleChoice.feedbackTime || 3
      this.options = singleChoice.options || [{}]
      this.alignement = singleChoice.alignement || 'v-layout'
      this.colorScheme = singleChoice.colorScheme || {}
      this.hasImage = singleChoice.hasImage || false
    },
    updateField(field, eventOrValue) {
      this[field] = eventOrValue.target ? eventOrValue.target.value : eventOrValue
      
      if (field === 'hasImage') {
        this['alignement'] = eventOrValue ? 'h-layout' : 'v-layout'
      }

      this.updateSingleChoiceTag()
    },
    updateLangField(field, lang, eventOrValue) {
      console.log("updateField", field, lang, eventOrValue)
      this[field][lang] = eventOrValue.target ? eventOrValue.target.value : eventOrValue
      this.updateSingleChoiceTag()
    },
    updateOption(i, option) {
      this.options[i] = option
      this.updateSingleChoiceTag()
    },
    updateSingleChoiceTag() {
      const { question, options, name, instruction, feedbackTime, alignement, colorScheme, hasImage } = this
      this.updateSingleChoice({ name, singleChoice: { question, options, instruction, feedbackTime, alignement, colorScheme, hasImage } })
    },
    deleteOption(i) {
      this.options.splice(i, 1)
      this.keyPart = new Date().toTimeString()
      this.updateSingleChoiceTag()
    },
    reorder({ oldIndex, newIndex }) {
      const movedItem = this.options.splice(oldIndex, 1)[0]
      this.options.splice(newIndex, 0, movedItem)
      this.keyPart = new Date().toTimeString()
      this.updateSingleChoiceTag()
    },
    addOption() {
      this.options.push({})
    },
    onApplyToAllLangs: function(ev) {
      let textVal = this.question[ev]
      for (const k in this.question) {
        if (k !== 'lang') {
          this.question[k] = textVal
        }
      }
    }
  }
}

</script>
